import { Controller } from '@hotwired/stimulus'
import Dropdown from 'flowbite/lib/esm/components/dropdown'
import { stimulus } from '~/init'

export default class DropdownController extends Controller {
  static targets = ['trigger', 'menu', 'autofocus', 'arrow']

  connect () {
    this.dropdown = new Dropdown(this.menuTarget, this.triggerTarget, this.#options())
  }

  disconnect () {
    this.dropdown.hide()
  }

  hide () {
    this.dropdown.hide()
  }

  #options () {
    const { placement, triggertype, offsetskidding, offsetdistance, delay, ignoreclickoutsideclass } = this.element.dataset

    return {
      placement: placement || 'bottom-end',
      triggerType: triggertype || 'click',
      offsetSkidding: parseInt(offsetskidding) || 0,
      offsetDistance: parseInt(offsetdistance) || 5,
      delay: parseInt(delay) || 300,
      ignoreClickOutsideClass: ignoreclickoutsideclass || false,
      onShow: () => {
        this.#handleShow()
      },
      onHide: () => {
        this.#handleHide()
      }
    }
  }

  #handleShow () {
    if (this.hasAutofocusTarget) {
      this.autofocusTarget.focus()
    }
    this.#rotateArrow(true)
  }

  #handleHide () {
    this.#rotateArrow(false)
  }

  #rotateArrow (isOpen) {
    if (this.hasArrowTarget) {
      if (isOpen) {
        this.arrowTarget.classList.add('rotate-180')
      } else {
        this.arrowTarget.classList.remove('rotate-180')
      }
    }
  }
}

stimulus.register('dropdown', DropdownController)
